<script lang="ts" setup>
import UiMultiSelect, { MultiSelectOption } from '@/ui/form/UiMultiSelect.vue';
import { IconName } from '../UiIcon.vue';

interface Props {
  // from UiField
  error?: string;
  errors?: string[];
  label?: string;
  name?: string;
  hint?: string;
  isDarkBackground?: boolean;

  // from UiMultiSelect
  modelValue: string[];
  options: MultiSelectOption[];
  placeholder?: string;
  placeholderIcon?: IconName;
  disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'update:modelValue', p: string[]): void;
  (e: 'open'): void;
  (e: 'close'): void;
}>();

const modelValueProxy = computed<string[]>({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <UiField
    :error="props.error"
    :errors="props.errors"
    :label="props.label"
    :name="props.name"
    :hint="props.hint"
    :is-dark-background="props.isDarkBackground"
  >
    <UiMultiSelect
      v-model="modelValueProxy"
      :options="props.options"
      :disabled="props.disabled"
      :placeholder="props.placeholder"
      :placeholder-icon="props.placeholderIcon"
      @close="$emit('close')"
      @open="$emit('open')"
    />
  </UiField>
</template>
